export enum AuthErrorCode {
  NoAccessToken = 0,
  NoRefreshToken = 1,
}

export class AuthError extends Error {
  constructor(
    message: string,
    public code: AuthErrorCode,
  ) {
    super(message);
    this.name = 'AuthError';
  }
}

export function isAuthErrorNoAccessToken(error: unknown): error is AuthError {
  return (
    error != null &&
    error instanceof AuthError &&
    error.code === AuthErrorCode.NoAccessToken
  );
}
